import api from "api";

export const buscarAusenciaReporte = async (body) => {
  const res = await api.post(
    "/backoffice/buscarAusenciaReporte",
    body
  );
  return res.data;
};
